export default {
    "确认": "確認",
    "取消": "取消",
    "选择语言": "選擇語言",
    "切换语言成功": "切換語言成功",
    "首页": "首頁",
    "申购": "申購",
    "团队": "團隊",
    "交易进行中,请勿进行其他操作": "交易進行中，請勿進行其他操作",
    "资金管理": "資金管理",
    "资金明细": "資金明細",
    "我的订单": "我的訂單",
    "订单详情": "訂單詳情",
    "没有更多了": "沒有更多了",
    "加载中": "加載中",
    "代币价格": "代幣價格",
    "收益概览": "收益概覽",
    "申购收益": "申購收益",
    "分享收益": "分享收益",
    "官方网站": "官方網站",
    "官网": "官網",
    "电报": "電報",
    "推特": "推特",
    "白皮书": "白皮書",
    "申购金额": "申購金額",
    "请输入入金金额": "請輸入入金金額",
    "快捷申购": "快捷申購",
    "申购比例": "申購比例",
    "赠币数量": "贈幣數量",
    "立即申购": "立即申購",
    "更多": "更多",
    "订单": "訂單",
    "分红中": "分紅中",
    "已完成": "已完成",
    "累计分红": "累計分紅",
    "申购信息": "申購信息",
    "兑换数量": "兌換數量",
    "开始时间": "開始時間",
    "提现成功": "提現成功",
    "订单编号": "訂單編號",
    "团队数据总览": "團隊數據總覽",
    "我的推广链接": "我的推廣鏈接",
    "复制": "複製",
    "分享此链接邀请好友加入团队，获取推广奖励": "分享此鏈接邀請好友加入團隊，獲取推廣獎勵",
    "团队业绩": "團隊業績",
    "当前等级": "當前等級",
    "今日收益": "今日收益",
    "团队用户": "團隊用戶",
    "有效团队": "有效團隊",
    "有效用户": "有效用戶",
    "无效团队": "無效團隊",
    "直推用户": "直推用戶",
    "有效直推": "有效直推",
    "无效直推": "無效直推",
    "资产余额数据概览": "資產餘額數據概覽",
    "提现": "提現",
    "选中币种": "選中幣種",
    "提现数量": "提現數量",
    "确认提现": "確認提現",
    "分红收入": "分紅收入",
    "直推奖励": "直推獎勵",
    "团队奖励": "團隊獎勵",
    "全部": "全部",
    "收入": "收入",
    "支出": "支出",
    "请输入正确的金额": "請輸入正確的金額",
    "申购成功": "申購成功",
    "申购失败": "申購失敗",
    "提现成功": "提現成功",
    "提现失败": "提現失敗",
    "提现信息": "提現信息",
    "提现币种": "提現幣種",
    "提现数量": "提現數量",
    "请选择币种": "請選擇幣種",
    "钱包余额不足": "錢包餘額不足",
    "提现手续费": "提現手續費",
    "间推奖励": "間推獎勵",
    "团队奖励": "團隊獎勵",
    "提现失败退还": "提現失敗退還",
    "ido申购": "ido申購",
    "ido申购赠送": "ido申購贈送",
    "链式去中心化全球点火网络": "莫斯科州唯一的老牌數字資產交易所",
    "长期价值": "長期價值",
    "智能涌现": "智能湧現",
    "协议永生": "協議永生",
    "立即进入": "立即進入",
    "大区累计业绩": "大區累計業績",
    "小区累计业绩": "小區累計業績",
    "复制成功": "複製成功",
    "复制失败": "複製失敗",
    "暂无数据": "暫無數據",
    "平级奖励": "平級獎勵",
}